function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 18,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_98330_290664)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.7357 15.5464C12.4122 14.8699 13.1767 14.3254 13.9851 13.913C14.2436 13.7865 14.4086 13.5225 14.4086 13.2255L14.1886 11.2786C16.4875 10.4646 19.3474 10.4096 21.7342 11.2456L21.5747 13.231C21.5802 13.5335 21.7507 13.792 22.0037 13.924C22.8177 14.3309 23.5766 14.8809 24.2531 15.5574C24.5501 15.8544 25.0451 15.8544 25.342 15.5574L27.2449 13.6545C27.5419 13.3575 27.7674 12.868 27.3549 12.4555C22.2457 7.34629 13.7486 7.35179 8.6449 12.4555C8.25442 12.846 8.44691 13.3465 8.74939 13.649L10.6468 15.5464C10.9438 15.8434 11.4388 15.8434 11.7357 15.5464Z",
  fill: "#C40202"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.2803 18.2803C22.5732 17.9874 22.5732 17.5126 22.2803 17.2197C21.9874 16.9268 21.5126 16.9268 21.2197 17.2197L18 20.4393L14.7803 17.2197C14.4874 16.9268 14.0126 16.9268 13.7197 17.2197C13.4268 17.5126 13.4268 17.9874 13.7197 18.2803L16.9393 21.5L13.7197 24.7197C13.4268 25.0126 13.4268 25.4874 13.7197 25.7803C14.0126 26.0732 14.4874 26.0732 14.7803 25.7803L18 22.5607L21.2197 25.7803C21.5126 26.0732 21.9874 26.0732 22.2803 25.7803C22.5732 25.4874 22.5732 25.0126 22.2803 24.7197L19.0607 21.5L22.2803 18.2803Z",
  fill: "#C40202"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_98330_290664"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(8 8)"
})));

function SvgRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed);
export default __webpack_public_path__ + "static/media/red.547dbb31.svg";
export { ForwardRef as ReactComponent };